import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useAppSelector } from '../../../hooks';
import { selectMatchState } from '../../../store/match';
import { OldMatchDesk } from '../OldMatchDesk';
export function OldDeskPool({ onPlayerClickAction, gameButtonState, addOnComponent }) {
    const matchState = useAppSelector(selectMatchState);
    const [matchPlayers, setMatchPlayers] = useState([]);
    const [deskPool, setDeskPool] = useState(null);
    const [viewDesk, setViewDesk] = useState(1);
    const [currentPlayerId, setCurrentPlayerId] = useState(null);
    useEffect(() => {
        setMatchPlayers((matchState === null || matchState === void 0 ? void 0 : matchState.players) || []);
    }, [matchState]);
    const playerInDesk = (playerId, players) => !!players.find((p) => p.id === playerId);
    const findDeskByPlayer = (playerId) => {
        const res = deskPool === null || deskPool === void 0 ? void 0 : deskPool.pool.find((desk) => playerInDesk(playerId, desk.players));
        return res === null || res === void 0 ? void 0 : res.deskNumber;
    };
    useEffect(() => {
        if (!currentPlayerId)
            return;
        const res = findDeskByPlayer(currentPlayerId);
        setViewDesk(res || 1);
    }, [currentPlayerId]);
    return (_jsx(OldMatchDesk, { players: matchPlayers, onClickPlayerAction: onPlayerClickAction, gameButtonState: gameButtonState, setCurrentPlayerId: setCurrentPlayerId, addOnComponent: addOnComponent }));
}
